import { mock } from '@npco/utils-apollo-testing-link'

import {
  GetProducts,
  GetProductsQueryResponse,
  GetProductsQueryVariables,
} from '../GetProducts.generated'

type ProductNode = NonNullable<
  NonNullable<GetProductsQueryResponse['site']['products']['edges']>[number]
>['node']

type ProductOptionsType = ProductNode['productOptions']

export const MOCK_PICKLIST_OPTIONS = {
  edges: [
    {
      node: {
        __typename: 'MultipleChoiceOption',
        entityId: 23,
        values: {
          edges: [
            {
              node: {
                entityId: 136,
                __typename: 'ProductPickListOptionValue',
              },
              __typename: 'ProductOptionValueEdge',
            },
          ],
          __typename: 'ProductOptionValueConnection',
        },
      },
      __typename: 'ProductOptionEdge',
    },
    {
      node: {
        __typename: 'MultipleChoiceOption',
        entityId: 24,
        values: {
          edges: [
            {
              node: {
                entityId: 137,
                __typename: 'ProductPickListOptionValue',
              },
              __typename: 'ProductOptionValueEdge',
            },
            {
              node: {
                entityId: 139,
                __typename: 'ProductPickListOptionValue',
              },
              __typename: 'ProductOptionValueEdge',
            },
          ],
          __typename: 'ProductOptionValueConnection',
        },
      },
      __typename: 'ProductOptionEdge',
    },
  ],
  __typename: 'ProductOptionConnection',
} satisfies ProductOptionsType

export const GET_PRODUCT_RESPONSE = {
  site: {
    products: {
      edges: [
        {
          node: {
            entityId: 142,
            name: 'Zeller Terminal - White',
            description: `<p><strong>Exclusive to myzeller.com</strong>. Buy Australia's favourite<br />EFTPOS solution with 5 free items, <strong>for only $99.</strong></p>`,
            sku: 'TER-WHT-1-AU',
            plainTextDescription: '',
            defaultImage: {
              url320wide:
                'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/404/T1_-_White_side__11185.1717048636.png',
              altText: 'Zeller Terminal White Default',
              __typename: 'Image',
            },
            images: {
              edges: [
                {
                  node: {
                    url320wide:
                      'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/404/T1_-_White_side__11185.1717048636.png',
                    altText: 'Zeller Terminal White Default',
                    __typename: 'Image',
                  },
                  __typename: 'ImageEdge',
                },
                {
                  node: {
                    url320wide:
                      'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/407/T1_Dock_-_White__53404.1717048635.png',
                    altText: 'Charging Dock',
                    __typename: 'Image',
                  },
                  __typename: 'ImageEdge',
                },
                {
                  node: {
                    url320wide:
                      'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/402/Debit_Card_-_White__93408.1717048635.jpg',
                    altText: 'Zeller Debit Card',
                    __typename: 'Image',
                  },
                  __typename: 'ImageEdge',
                },
                {
                  node: {
                    url320wide:
                      'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/408/T1_Charger_-_White__74051.1718084466.png',
                    altText: 'Charging cable',
                    __typename: 'Image',
                  },
                  __typename: 'ImageEdge',
                },
                {
                  node: {
                    url320wide:
                      'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/409/Sticker_Set_-_White__50452.1718084546.png',
                    altText: 'Sticker kit',
                    __typename: 'Image',
                  },
                  __typename: 'ImageEdge',
                },
                {
                  node: {
                    url320wide:
                      'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/410/Receipt_Paper_-_White__29329.1718084476.png',
                    altText: 'Receipt paper',
                    __typename: 'Image',
                  },
                  __typename: 'ImageEdge',
                },
              ],
              __typename: 'ImageConnection',
            },
            prices: {
              price: {
                value: 99,
                __typename: 'Money',
              },
              salePrice: {
                value: 99,
                __typename: 'Money',
              },
              basePrice: {
                value: 259,
                __typename: 'Money',
              },
              __typename: 'Prices',
            },
            productOptions: {
              edges: [
                {
                  node: {
                    __typename: 'MultipleChoiceOption',
                    entityId: 23,
                    values: {
                      edges: [
                        {
                          node: {
                            entityId: 136,
                            __typename: 'ProductPickListOptionValue',
                          },
                          __typename: 'ProductOptionValueEdge',
                        },
                      ],
                      __typename: 'ProductOptionValueConnection',
                    },
                  },
                  __typename: 'ProductOptionEdge',
                },
                {
                  node: {
                    __typename: 'MultipleChoiceOption',
                    entityId: 24,
                    values: {
                      edges: [
                        {
                          node: {
                            entityId: 137,
                            __typename: 'ProductPickListOptionValue',
                          },
                          __typename: 'ProductOptionValueEdge',
                        },
                      ],
                      __typename: 'ProductOptionValueConnection',
                    },
                  },
                  __typename: 'ProductOptionEdge',
                },
              ],
              __typename: 'ProductOptionConnection',
            },
            __typename: 'Product',
          },
          __typename: 'ProductEdge',
        },
        {
          node: {
            entityId: 141,
            name: 'Zeller Terminal - Black',
            description: `<p><strong>Exclusive to myzeller.com</strong>. Buy Australia's favourite<br />EFTPOS solution with 5 free items, <strong>for only $99.</strong></p>`,
            sku: 'TER-BLK-1-AU',
            plainTextDescription: '',
            defaultImage: {
              url320wide:
                'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/141/400/T1_-_Black_side__01222.1717048316.png',
              altText: 'Zeller Terminal Black Default',
              __typename: 'Image',
            },
            images: {
              edges: [
                {
                  node: {
                    url320wide:
                      'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/141/400/T1_-_Black_side__01222.1717048316.png',
                    altText: 'Zeller Terminal Black Default',
                    __typename: 'Image',
                  },
                  __typename: 'ImageEdge',
                },
                {
                  node: {
                    url320wide:
                      'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/141/401/dock_-_2020_11_-_white_-_right_34_-_res_initial_-_art_-_v1_-_r1__33890.1717048317.png',
                    altText: 'Charging Dock',
                    __typename: 'Image',
                  },
                  __typename: 'ImageEdge',
                },
                {
                  node: {
                    url320wide:
                      'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/141/396/Debit_Card_-_Black__19706.1717048315.jpg',
                    altText: 'Zeller Debit Card',
                    __typename: 'Image',
                  },
                  __typename: 'ImageEdge',
                },
                {
                  node: {
                    url320wide:
                      'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/141/413/T1_Charger_-_Black__91414.1718084529.png',
                    altText: 'Charging cable',
                    __typename: 'Image',
                  },
                  __typename: 'ImageEdge',
                },
                {
                  node: {
                    url320wide:
                      'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/141/412/Sticker_Set_-_White__49399.1718084528.png',
                    altText: 'Sticker kit',
                    __typename: 'Image',
                  },
                  __typename: 'ImageEdge',
                },
                {
                  node: {
                    url320wide:
                      'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/141/411/Receipt_Paper_-_White__52817.1718084527.png',
                    altText: 'Receipt roll',
                    __typename: 'Image',
                  },
                  __typename: 'ImageEdge',
                },
              ],
              __typename: 'ImageConnection',
            },
            prices: {
              price: {
                value: 99,
                __typename: 'Money',
              },
              salePrice: {
                value: 99,
                __typename: 'Money',
              },
              basePrice: {
                value: 259,
                __typename: 'Money',
              },
              __typename: 'Prices',
            },
            productOptions: {
              edges: [
                {
                  node: {
                    __typename: 'MultipleChoiceOption',
                    entityId: 27,
                    values: {
                      edges: [
                        {
                          node: {
                            entityId: 139,
                            __typename: 'ProductPickListOptionValue',
                          },
                          __typename: 'ProductOptionValueEdge',
                        },
                      ],
                      __typename: 'ProductOptionValueConnection',
                    },
                  },
                  __typename: 'ProductOptionEdge',
                },
                {
                  node: {
                    __typename: 'MultipleChoiceOption',
                    entityId: 28,
                    values: {
                      edges: [
                        {
                          node: {
                            entityId: 140,
                            __typename: 'ProductPickListOptionValue',
                          },
                          __typename: 'ProductOptionValueEdge',
                        },
                      ],
                      __typename: 'ProductOptionValueConnection',
                    },
                  },
                  __typename: 'ProductOptionEdge',
                },
              ],
              __typename: 'ProductOptionConnection',
            },
            __typename: 'Product',
          },
          __typename: 'ProductEdge',
        },
      ],
      __typename: 'ProductConnection',
    },
    __typename: 'Site',
  },
} satisfies GetProductsQueryResponse

const MissingProducts = GET_PRODUCT_RESPONSE.site.products.edges.map(
  (data) => ({
    ...data,
    node: {
      ...data.node,
      prices: {
        ...data.node.prices,
        price: { ...data.node.prices.price, value: null },
      },
    },
  })
)

const GET_PRODUCT_RESPONSE_WITH_MISSING_PRICE = {
  site: {
    products: {
      edges: MissingProducts,
    },
  },
} satisfies GetProductsQueryResponse

export const PRODUCT_DISPLAY_MOCK = {
  id: 142,
  name: 'Zeller Terminal - White',
  description: `<p><strong>Exclusive to myzeller.com</strong>. Buy Australia's favourite<br />EFTPOS solution with 5 free items, <strong>for only $99.</strong></p>`,
  primaryImage: {
    url320wide:
      'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/404/T1_-_White_side__11185.1717048636.png',
    altText: 'Zeller Terminal White Default',
  },
  price: 99,
  slashedPrice: 259,
  accessoryImages: [
    {
      url: 'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/404/T1_-_White_side__11185.1717048636.png',
      tooltip: 'Zeller Terminal White',
    },
    {
      url: 'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/407/T1_Dock_-_White__53404.1717048635.png',
      tooltip: 'Charging Dock',
    },
    {
      url: 'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/402/Debit_Card_-_White__93408.1717048635.jpg',
      tooltip: 'Zeller Debit Card',
    },
    {
      url: 'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/408/T1_Charger_-_White__74051.1718084466.png',
      tooltip: 'Charging cable',
    },
    {
      url: 'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/409/Sticker_Set_-_White__50452.1718084546.png',
      tooltip: 'Sticker kit',
    },
    {
      url: 'https://cdn11.bigcommerce.com/s-5hrs4erpxb/images/stencil/320w/products/142/410/Receipt_Paper_-_White__29329.1718084476.png',
      tooltip: 'Receipt paper',
    },
  ],
}

export const SUCCESS_VARIABLE = {
  pageSize: 10,
} satisfies GetProductsQueryVariables

export const GetProductsMocks = mock<
  GetProductsQueryVariables,
  GetProductsQueryResponse
>(GetProducts)

export const GetProductsSuccessMocks =
  GetProductsMocks.mockVariables(SUCCESS_VARIABLE).mockData(
    GET_PRODUCT_RESPONSE
  )

export const GetMissingPriceProductsMock = GetProductsSuccessMocks.mockData(
  GET_PRODUCT_RESPONSE_WITH_MISSING_PRICE
)

export const GetProductsErrorMocks = GetProductsMocks.mockGraphQLErrors()

export const GetProductsNetworkErrorMock = GetProductsMocks.mockNetworkError()
